module.exports = __webpack_public_path__ + "static/media/ic_save_icon_disable.7ca7f361.svg";